import React, { useRef, useState } from 'react';
import axios from 'axios';
import "./BusinessServices.css";
import flashMessage from '../HelperFunctions';


function BusinessServices({ organization, onChange }) {
  const [isSaving, setIsSaving] = useState(false);  // State to handle "saving..." message
  const placeholderText = `Tell your AI receptionist about the services your business offers.`;

  const typingTimer = useRef(null);
  const servicesInputRef = useRef(null);


  const handleInputChange = (e) => {
    onChange(e.target.value);
  };

  return (

    <div style={{  }}  className="customize-ai-section">
    <span>
      Services
    </span>
      <textarea
        data-say-id="knowledge-base-services"
        ref={servicesInputRef}
        className="business-services-text"
        placeholder={placeholderText}
        defaultValue={organization.business_services}
        onChange={handleInputChange}
      />

    </div>

  );
}

export default BusinessServices
